export default __webpack_public_path__ + "resources/icons/n120-6dc5.png";